import { AxiosRequestConfig } from "axios";
import ApiBase from "../apiRequestBase";
import { ReplyPostRequest } from "../../models/communityTalk/replyPostRequest";
import { ReplyGetRequest } from "../../models/communityTalk/replyGetRequest";
import { ReplyGetResponse } from "../../models/communityTalk/replyGetResponse";

/**
 * リプライ周りのAPIへのリクエスト。
 */
export default class ReplyApiRequest {
	/**
	 * replyのPOSTリクエスト
	 */
	public async postReply(tenantId: string, request: ReplyPostRequest): Promise<string> {
		// リクエストの設定
		// params,headers等の設定もここで行う
		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/replies`,
			method: "POST",
			headers: {
				tenantId: tenantId,
			},
			data: request,
		};

		return (await ApiBase.requestWithApiToken<string>(tenantId, options)) as string;
	}

	/**
	 * repliesのGETリクエスト
	 * @returns
	 */
	public async getReplies(tenantId: string, request: ReplyGetRequest): Promise<ReplyGetResponse> {
		// リクエストの設定
		// params,headers等の設定もここで行う

		const options: AxiosRequestConfig = {
			url: `${process.env.VUE_APP_API_ENDPOINT}/replies`,
			headers: {
				tenantId: tenantId,
			},
			params: request,
			method: "GET",
		};

		return (await ApiBase.request<ReplyGetResponse>(options)) as ReplyGetResponse;
	}
}
